<template>
    <div class="box vh-140">
        <div class="box-header">
            <i class="fa fa-th-large"></i><h3 class="box-title">充值列表</h3>
        </div>
        <div class="box-body">
            <el-table class="list-table" :data="rechargeList" border :stripe="true" style="width: 100%" :header-cell-style="{ background: '#eef1f6', color: '#606266' }">
              <template slot="empty">
                <div class="no-data-post">暂无数据！</div>
              </template>
                <el-table-column label="序号" width="50">
                    <template slot-scope="scope">
                        <span>{{page.pageSize * (page.pageNo - 1) + scope.$index + 1}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="schemeName" label="方案"></el-table-column>
                <el-table-column prop="amount" label="购买套数" width="100"></el-table-column>
                <el-table-column prop="created" label="时间" :formatter="formatTime" width="200"></el-table-column>
            </el-table>

            <!-- 分页 -->
            <page-bar v-model="page" @change="fetchData"></page-bar>
        </div>

    </div>
</template>

<script>
    import {getBuyHistory} from '@/api/evaluation/project'
    import PageBar from '@/components/PageBar.vue'
    import {parseTime} from '@/utils/index'

    export default {
        name:'ev-recharge',
        components:{
            PageBar
        },
        created() {
            this.fetchData();
        },
        methods: {
            fetchData() {
                getBuyHistory(this.userId,this.page).then(resp => {
                    let data = resp.data.result
                    this.$set(this.page,'total',data.total)
                    this.$set(this.page,'pageNo',data.pageNo)
                    this.$set(this.page,'pageSize',data.pageSize)
                    this.rechargeList = data.records;
                })
            },
            formatTime: function (row, column, val) {
                return parseTime(val);
            },
        },
        data: function () {
            return {
                page: {
                    pageSize: 20,
                    pageNo: 1
                },
                userId: this.$store.state.user.info.id,
                rechargeList: [],
                recharge:{}
            }
        }
    }
</script>
